import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get, sumBy, groupBy } from 'lodash';
import moment from 'moment';
import CircularProgress from '@material-ui/core/CircularProgress';

import {
  formatPrice,
} from 'helpers/utils';

import {
  injectIntl,
  PrintableTable,
} from 'components';
import Checkbox from '@material-ui/core/Checkbox';



class HarvestListCard extends Component {
  static contextTypes = {
    isDistributor: PropTypes.bool,
    isFarmer: PropTypes.bool,
    isRestaurant: PropTypes.bool,
  };

  static propTypes = {
    deliveryDate: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    packListInfo: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ),

    formatMessage: PropTypes.func.isRequired,
    printHeaderChecked: PropTypes.arrayOf(PropTypes.bool).isRequired,
    checkUpdated: PropTypes.func.isRequired,

  };

  static defaultProps = {
    packListInfo: [],
  };

  getPackListData = () => {
    const { packListInfo } = this.props;

    const dataList = packListInfo.map(({ quantity, order, data, packrow }) => ({
      item_name: `${get(data, 'productData.name')}, ${get(data, 'productData.subname')}`,
      itemTags: get(data, 'tags').join(', '),
      itemDescription: get(data, 'description'),
      item_qty: quantity,
      item_uom: `${packrow.count} ${packrow.uom} ${packrow.pack}`,
      item_price: '$' + formatPrice(packrow.price),
      item_price2: packrow.price,
      customer_code: get(order, 'contact.buyerCompanyCode'),
      customer: get(order, 'contact.buyerProfile.companyName'),
      isParent: false,
    }));

    const dataListNoZeroItems = dataList.filter(item => item.item_qty>0);
    const groupedInfo = groupBy(dataListNoZeroItems,(item)=>`${item.item_name}--${item.item_uom}`);
    const groupIds = Object.keys(groupedInfo);
    const groupedArray = groupIds.map(groupId => groupedInfo[groupId]);
    groupedArray.map( item => {
      const totalQty = sumBy(item,'item_qty');

      //add parentItem
      item.unshift({
        item_name: item[0].item_name,
        itemTags: item[0].itemTags,
        itemDescription: item[0].itemDescription,
        item_uom: item[0].item_uom,
        item_qty: totalQty,
        item_total_price: '$' + formatPrice(item[0].item_price2 * totalQty),
        isParent: true,
      })
    });

    const result=[];

    //concat all the items
    groupedArray.forEach((itemInfo) => {
      result.push(...itemInfo);
    });

    return result;
  }

  updateCheck = (isChecked, index) => {
    const { checkUpdated } = this.props;
    checkUpdated(isChecked, index);
  }


  render() {
    const {
      deliveryDate,
      loading,
      formatMessage,
      printHeaderChecked,
    } = this.props;
    const packListHeader = `${formatMessage('Harvest list for')} ${moment(deliveryDate).format('LLLL')}`;
    const packInfo = this.getPackListData();
    const totalItemsFields = [
      {
        className: 'highlight',
        colSpan: 2,
        label: formatMessage('IN'),
        name: 'item_name',
        render: data => data.isParent ? data.item_name : '',
      },
      {
        className: 'highlight',
        colSpan: 1,
        label: formatMessage('Tags'),
        name: 'itemTags',
        render: data => data.isParent ? data.itemTags : '',
      },
      {
        colSpan: 3,
        label: formatMessage('Description'),
        name: 'itemDescription',
        render: data => data.isParent ? data.itemDescription : '',
      },
      {
        label: formatMessage('Qty'),
        name: 'item_qty',
        render: data => ( data.isParent ?
              <span className = 'bold'>
                {data.item_qty}
              </span> : 
              <span>
                {data.item_qty}
              </span> 
        ),
      },
      {
        label: formatMessage('Pack-Out'),
        name: 'item_uom',
        render: data => data.isParent ? data.item_uom : '',
      },
      {
        label: formatMessage('Customer Code'),
        name: 'customer_code',
        render: data => !data.isParent ? (
          data.customer_code
        ) : '',
      },
      {
        label: formatMessage('Customer'),
        name: 'customer',
        render: data => !data.isParent ? (
          data.customer
        ) : '',
      },
      {
        label: formatMessage('Total Price'),
        name: 'item_total_price',
        render: data => data.isParent ? data.item_total_price : '',
      },
    ];

    return (
      <div>
        {
          loading && (
            <div className="print-progress">
              <CircularProgress />
            </div>
          )
        }
        {packListHeader ? (
          <div>
            <div className="packlist-header">{packListHeader}</div>
            <div className="checked-list">
                {
                  totalItemsFields.map((field, index) => (
                    <span key={index}>
                      <Checkbox
                        checked={printHeaderChecked[index]}
                        onChange={(e, isInputChecked) => this.updateCheck(isInputChecked, index)}
                      />
                      {field.label}
                    </span>
                  ))
                }
              </div>

            <PrintableTable
              checkedArray={printHeaderChecked}
              data={packInfo}
              fields={totalItemsFields}
            />
          </div>) : ''
        }
      </div>
    );
  }
}

const wrappedHarvestListCard = injectIntl(HarvestListCard);
wrappedHarvestListCard.displayName = 'HarvestListCard';

export default wrappedHarvestListCard;
